import PayNowButton from './PayNowButton'

export * from './types'

export default PayNowButton
